import { Navigate, useSearchParams } from "react-router-dom"
import { formatCurrency } from "src/utils/helper"

export const OrderResult = () => {
  const token = localStorage.getItem('access_token')
  if (!token) {
    Navigate('/')
  }

  const [searchParams] = useSearchParams()
  const statusOrder = searchParams.get('vnp_TransactionStatus')
  const amount = searchParams.get('vnp_Amount')
  const bankCode = searchParams.get('vnp_BankCode')
  return (
    <>
    <div className="pt-10 w-full max-w-[1200px] mx-auto pl-12 pr-12 pb-10">
      <div className="">
        <h1 className="text-4xl font-bold text-center">Kết quả thanh toán</h1>
        <p className="text-2xl">
          Trạng thái: {statusOrder === '00' ? 'Thanh toán thành công' : 'Thanh toán thất bại'}
        </p>
        <p className="text-2xl">
          Số tiền: {formatCurrency(Number(amount) / 100)}
        </p>
        <p className="text-2xl">
          Mã ngân hàng: {bankCode}
        </p>
      </div>
    </div>
    </>
  )
}